import script from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"

import "./InvestSummary.vue?vue&type=style&index=0&id=1b71b24f&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b71b24f"]])

export default __exports__